const notificationTemplate = require("./notification.html.slim");
declare var angular

export class TransferNotification {
  static $inject = ['$scope']

  title: string;
  body: any;
  notifications: any[];

  constructor(public $scope) {
    this.notifications = JSON.parse(this.body);
  }

}

angular.module('wbComponents').directive('wbTransferNotification', function() {
  return {
    restrict: 'E',
    templateUrl: notificationTemplate,
    controller: TransferNotification,
    controllerAs: 'ctrl',
    bindToController: true,
    scope: {
      title: '@',
      body: '@'
    }
  }
})
